import { render } from "./SpConnectOptInContent.vue?vue&type=template&id=befa09ea&scoped=true&ts=true"
import script from "./SpConnectOptInContent.vue?vue&type=script&lang=ts"
export * from "./SpConnectOptInContent.vue?vue&type=script&lang=ts"

import "./SpConnectOptInContent.vue?vue&type=style&index=0&id=befa09ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befa09ea"]])

export default __exports__